import { TweenMax, Power2 } from 'gsap';

import $ from 'jquery';

global.jQuery = require('jquery');



$(document).ready(function(){

    let screen = window.screen

    console.log("checking screen size...", screen);
    let screenHeight = $(screen.availHeight - 80)
    console.log("checking screenHeight:", screenHeight[0]+"px");



//////////////////////// ON PAGE LOAD //////////////////////////


// HEADER


  // logo fade in to shimmer

  $('#overlay_logo').addClass('custom-fade-in-1').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('custom-fade-in-1');
    $(this).addClass('animate-shimmer-3');
  });


  // social icons hover

  $('.header__social').hover(function(){
    $(this).css("opacity", 1);
    }, function(){
    $(this).css("opacity", 0);
  })


  // caption_letters fade in to shimmer

  $('#caption_letter__1').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__2').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__3').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__4').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__5').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__6').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__7').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__8').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__9').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__10').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__11').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__12').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__13').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__14').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__15').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__16').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__17').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__18').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__19').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__20').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__21').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__22').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__23').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__24').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });


  $('#caption_letter__25').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__26').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__27').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__28').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__29').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__30').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__31').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__32').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__33').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__34').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__35').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__36').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#caption_letter__37').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });


  // caption words fade in to shimmer

  $('#word__1').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__2').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__3').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__4').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__5').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__6').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__7').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__8').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__9').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__10').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__11').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__12').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__13').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__14').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__15').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#word__16').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });



  // mouse graphic


  let mouse_graphic_icon = $('.mouse_graphic_icon');

  $('.mouse_graphic').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated fadeIn');
      $(this).addClass('animated mouse_graphic_animation');
      $(this).css('animation-delay', '12s').css('animation-duration', '12s');

    }
  );





  TweenMax.to(mouse_graphic_icon, 2.8, {
    marginTop: 60,
    opacity: 0,
    ease: Power2.easeInOut,

    repeat: -1
  })




  // back to top


  $('#backToTop_hover').hover(function(){
      $(this).css("background-color", '#00A1D8');
    }, function(){
      $(this).css('background', "black");
    });


  // $('.backToTop').addClass('animate-shimmer-3');


  // .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
  //     $(this).removeClass('wow animated fadeIn');
  //     $(this).addClass('animate-shimmer');
  //     // $(this).addClass('animate-shimmer-3');
  //     $(this).css('animation-duration', '10s');
  //
  //   }
  // );

  $('.backToTop_icon').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated fadeIn');
      $(this).addClass('animated backToTop_animation');
      $(this).css('animation-duration', '8s');

    }
  );


  // TweenMax.to(backToTop_icon, 1.3, {
  //   marginTop: '0px',
  //   opacity: 0,
  //   ease: Power2.easeInOut,
  //
  //   repeat: -1
  // })



  // work p words fade in to shimmer

  $('#work_p_word__1').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__2').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__3').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__4').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__5').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__6').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__7').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__8').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });
  $('#work_p_word__9').addClass('animated fadeIn').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
    $(this).removeClass('animated fadeIn');
    $(this).addClass('animate-shimmer-2');
  });


/////////////////////////// ON SCROLL ///////////////////////////

  $(window).scroll(function(){


  // HEADER ANIMATION


      // WELCOME TO


      // W

      $('#letter_1').removeClass('animated bounceInDown ')
        $('#letter_1').css('animation-delay', '0s').css('animation-duration', '.7s')

      $('#letter_1').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // E

      $('#letter_2').removeClass('animated bounceInDown ')
        $('#letter_2').css('animation-delay', '0s').css('animation-duration', '1s')

      $('#letter_2').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // L

      $('#letter_3').removeClass('animated bounceInDown ')
        $('#letter_3').css('animation-delay', '.4s').css('animation-duration', '.8s')

      $('#letter_3').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // C

      $('#letter_4').removeClass('animated bounceInDown ')
        $('#letter_4').css('animation-delay', '.1s').css('animation-duration', '.9s')

      $('#letter_4').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // O

      $('#letter_5').removeClass('animated bounceInDown ')
        $('#letter_5').css('animation-delay', '0s').css('animation-duration', '1.2s')

      $('#letter_5').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // M

      $('#letter_6').removeClass('animated bounceInDown ')
        $('#letter_6').css('animation-delay', '.5s').css('animation-duration', '1.1s')

      $('#letter_6').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // E

      $('#letter_7').removeClass('animated bounceInDown ')
        $('#letter_7').css('animation-delay', '.3s').css('animation-duration', '1.5s')

      $('#letter_7').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // T

      $('#letter_8').removeClass('animated bounceInDown ')
        $('#letter_8').css('animation-delay', '.8s').css('animation-duration', '.7s')

      $('#letter_8').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // O

      $('#letter_9').removeClass('animated bounceInDown ')
        $('#letter_9').css('animation-delay', '0s').css('animation-duration', '.9s')

      $('#letter_9').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });



      // SONICLOUDS


      // S

      $('.letters#L1_S').removeClass('animated bounceInLeft ')
        $('.letters#L1_S').css('animation-delay', '0s').css('animation-duration', '.8s')

      $('.letters#L1_S').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // O

      $('.letters#L2_O').removeClass('animated bounceInDown ')
        $('.letters#L2_O').css('animation-delay', '.3s').css('animation-duration', '.9s')

      $('.letters#L2_O').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // N

      $('.letters#L3_N').removeClass('animated bounceInLeft ')
        $('.letters#L3_N').css('animation-delay', '.1s')

      $('.letters#L3_N').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // I

      $('.letters#L4_I').removeClass('animated bounceInDown ')
        $('.letters#L4_I').css('animation-delay', '.5s')

      $('.letters#L4_I').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // C

      $('.letters#L5_C').removeClass('animated bounceInLeft ')
        $('.letters#L5_C').css('animation-delay', '.3s').css('animation-duration', '.8s')

      $('.letters#L5_C').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // L

      $('.letters#L6_L').removeClass('animated bounceInDown ')
        $('.letters#L6_L').css('animation-delay', '.4s')

      $('.letters#L6_L').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // O

      $('.letters#L7_O').removeClass('animated bounceInRight ')
        $('.letters#L7_O').css('animation-delay', '0s').css('animation-duration', '.85s')

      $('.letters#L7_O').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // U

      $('.letters#L8_U').removeClass('animated bounceInDown ')
        $('.letters#L8_U').css('animation-delay', '.15s')

      $('.letters#L8_U').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // D

      $('.letters#L9_D').removeClass('animated bounceInRight ')
        $('.letters#L9_D').css('animation-delay', '.5s')

      $('.letters#L9_D').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });


      // S

      $('.letters#L10_S').removeClass('animated bounceInRight ')
        $('.letters#L10_S').css('animation-delay', '1.2s').css('animation-duration', '.9s')

      $('.letters#L10_S').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        $(this).removeClass('animated bounce');
      });

  }) // end scroll


///////////////////////////// ON RESIZE ///////////////////////////

  // var letters = document.getElementsByClassName('letters')

  $(window).resize(function(){
    console.log("checking screen size again...", screen);


    // SONICLOUDS


    // RESET PAGE LOAD ANIMATIONS

    $('.letters#L1_S').removeClass('animated bounceInLeft ')
      $('.letters#L1_S').css('animation-delay', '0s')

    $('.letters#L2_O').removeClass('animated bounceInDown')
      $('.letters#L2_O').css('animation-delay', '0s')

    $('.letters#L3_N').removeClass('animated bounceInLeft')
      $('.letters#L3_N').css('animation-delay', '0s')

    $('.letters#L4_I').removeClass('animated bounceInDown')
      $('.letters#L4_I').css('animation-delay', '0s')

    $('.letters#L5_C').removeClass('animated bounceInLeft')
      $('.letters#L5_C').css('animation-delay', '0s')

    $('.letters#L6_L').removeClass('animated bounceInDown')
      $('.letters#L6_L').css('animation-delay', '0s')

    $('.letters#L7_O').removeClass('animated bounceInRight')
      $('.letters#L7_O').css('animation-delay', '0s')

    $('.letters#L8_U').removeClass('animated bounceInDown')
      $('.letters#L8_U').css('animation-delay', '0s')

    $('.letters#L9_D').removeClass('animated bounceInRight')
      $('.letters#L9_D').css('animation-delay', '0s')

    $('.letters#L10_S').removeClass('animated bounceInRight')
      $('.letters#L10_S').css('animation-delay', '0s')


    // ADD NEW ANIMATIONS


    // S -- shake

    $('.letters#L1_S').addClass('animated shake').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated shake');
    });


    // O -- bounce

    $('.letters#L2_O').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // N -- bounce

    $('.letters#L3_N').addClass('animated bounce ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // I -- bounce

    $('.letters#L4_I').addClass('animated bounce ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce ');
    });


    // C -- bounce

    $('.letters#L5_C').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // L -- bounce

    $('.letters#L6_L').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // O -- bounce

    $('.letters#L7_O').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // U -- bounce

    $('.letters#L8_U').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // D -- bounce

    $('.letters#L9_D').addClass('animated bounce').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated bounce');
    });


    // S -- shake

    $('.letters#L10_S').addClass('animated shake').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated shake');
    });



    // WELCOME TO


    // RESET PAGE LOAD ANIMATIONS

    $('#letter_1').removeClass('animated bounceInDown')
      $('#letter_1').css('animation-delay', '0s')

    $('#letter_2').removeClass('animated bounceInDown')
      $('#letter_2').css('animation-delay', '0s')

    $('#letter_3').removeClass('animated bounceInDown')
      $('#letter_3').css('animation-delay', '0s')

    $('#letter_4').removeClass('animated bounceInDown')
      $('#letter_4').css('animation-delay', '0s')

    $('#letter_5').removeClass('animated bounceInDown')
      $('#letter_5').css('animation-delay', '0s')

    $('#letter_6').removeClass('animated bounceInDown')
      $('#letter_6').css('animation-delay', '0s')

    $('#letter_7').removeClass('animated bounceInDown')
      $('#letter_7').css('animation-delay', '0s')

    $('#letter_8').removeClass('animated bounceInDown')
      $('#letter_8').css('animation-delay', '0s')

    $('#letter_9').removeClass('animated bounceInDown')
      $('#letter_9').css('animation-delay', '0s')


    // ADD NEW ANIMATIONS (rubberBand)


    // W

    $('#letter_1').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // E

    $('#letter_2').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // L

    $('#letter_3').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // C

    $('#letter_4').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // O

    $('#letter_5').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // M

    $('#letter_6').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // E

    $('#letter_7').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // T

    $('#letter_8').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });


    // O

    $('#letter_9').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });



    // The work of David Chamberlin


    // RESET PAGE LOAD ANIMATIONS


    $('#caption_letter__1').removeClass('animated fadeIn')
      $('#caption_letter__1').css('animation-delay', '0s')

    $('#caption_letter__2').removeClass('animated fadeIn')
      $('#caption_letter__2').css('animation-delay', '0s')

    $('#caption_letter__3').removeClass('animated fadeIn')
      $('#caption_letter__3').css('animation-delay', '0s')

    $('#caption_letter__4').removeClass('animated fadeIn')
      $('#caption_letter__4').css('animation-delay', '0s')

    $('#caption_letter__5').removeClass('animated fadeIn')
      $('#caption_letter__5').css('animation-delay', '0s')

    $('#caption_letter__6').removeClass('animated fadeIn')
      $('#caption_letter__6').css('animation-delay', '0s')

    $('#caption_letter__7').removeClass('animated fadeIn')
      $('#caption_letter__7').css('animation-delay', '0s')

    $('#caption_letter__8').removeClass('animated fadeIn')
      $('#caption_letter__8').css('animation-delay', '0s')

    $('#caption_letter__9').removeClass('animated fadeIn')
      $('#caption_letter__9').css('animation-delay', '0s')

    $('#caption_letter__10').removeClass('animated fadeIn')
      $('#caption_letter__10').css('animation-delay', '0s')

    $('#caption_letter__11').removeClass('animated fadeIn')
      $('#caption_letter__11').css('animation-delay', '0s')

    $('#caption_letter__12').removeClass('animated fadeIn')
      $('#caption_letter__12').css('animation-delay', '0s')

    $('#caption_letter__13').removeClass('animated fadeIn')
      $('#caption_letter__13').css('animation-delay', '0s')

    $('#caption_letter__14').removeClass('animated fadeIn')
      $('#caption_letter__14').css('animation-delay', '0s')

    $('#caption_letter__15').removeClass('animated fadeIn')
      $('#caption_letter__15').css('animation-delay', '0s')

    $('#caption_letter__16').removeClass('animated fadeIn')
      $('#caption_letter__16').css('animation-delay', '0s')

    $('#caption_letter__17').removeClass('animated fadeIn')
      $('#caption_letter__17').css('animation-delay', '0s')

    $('#caption_letter__18').removeClass('animated fadeIn')
      $('#caption_letter__18').css('animation-delay', '0s')

    $('#caption_letter__19').removeClass('animated fadeIn')
      $('#caption_letter__19').css('animation-delay', '0s')

    $('#caption_letter__20').removeClass('animated fadeIn')
      $('#caption_letter__20').css('animation-delay', '0s')

    $('#caption_letter__21').removeClass('animated fadeIn')
      $('#caption_letter__21').css('animation-delay', '0s')

    $('#caption_letter__22').removeClass('animated fadeIn')
      $('#caption_letter__22').css('animation-delay', '0s')

    $('#caption_letter__23').removeClass('animated fadeIn')
      $('#caption_letter__23').css('animation-delay', '0s')

    $('#caption_letter__24').removeClass('animated fadeIn')
      $('#caption_letter__24').css('animation-delay', '0s')


    // ADD NEW ANIMATIONS (wobble)


    // T

    $('#caption_letter__1').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // h

    $('#caption_letter__2').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // e

    $('#caption_letter__3').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // w

    $('#caption_letter__4').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // o

    $('#caption_letter__5').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // r

    $('#caption_letter__6').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // k

    $('#caption_letter__7').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // o

    $('#caption_letter__8').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // f

    $('#caption_letter__9').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // D

    $('#caption_letter__10').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // a

    $('#caption_letter__11').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // v

    $('#caption_letter__12').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // i

    $('#caption_letter__13').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // d

    $('#caption_letter__14').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // C

    $('#caption_letter__15').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // h

    $('#caption_letter__16').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // a

    $('#caption_letter__17').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // m

    $('#caption_letter__18').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // b

    $('#caption_letter__19').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // e

    $('#caption_letter__20').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // r

    $('#caption_letter__21').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // l

    $('#caption_letter__22').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // i

    $('#caption_letter__23').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });


    // n

    $('#caption_letter__24').addClass('animated wobble').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated wobble');
    });



    // (Caption Paragraph) Full Stack...


    // RESET PAGE LOAD ANIMATIONS


    $('.overlay__caption p').removeClass('animated fadeIn')
      $('.overlay__caption p').css('animation-delay', '0s')


    // ADD NEW ANIMATION (rubberBand)

    $('.overlay__caption p').addClass('animated rubberBand').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
      $(this).removeClass('animated rubberBand');
    });



  }) // end .resize()


  // iFrame muting

  // let iframe = $('iframe');
  // iframe.muted = true;

  // let trailer = $('.trailer'),
  //     music_video = $('.music-video');
  //
  // trailer.muted = true;
  // music_video.muted = true;


}) // end function



// WEBPACK FOOTER //
// ./src/js_animations/customAnimations.js